// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getProductObligationData} from "../../../ExternalData/Product/ProductClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationProductGrid() {

    // ****************** BEGIN STATES ****************************

    const [productData, setProductData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchProductData = () =>
        getProductObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setProductData(data);
                console.log("This is my data used for the grid rows...");
                console.log(productData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My product grid should have displayed...");
        fetchProductData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.productGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({productGridOpen: false}));
    };


    function closeProductDataDrawer() {
        dispatchData(changeObligationHierarchy({productGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchProductData => [
        {    field: 'id',
            headerName: 'ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 60,
        },
        {
            field: 'externalId',
            headerName: 'External Id',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'name',
            headerName: 'Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 250,
        },
        {
            field: 'episodeName',
            headerName: 'Episode Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 250,
        },
        {
            field: 'seasonExternalId',
            headerName: 'Season ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'season',
            headerName: 'Season #',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 60,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 250,
        },

        {
            field: 'seriesExternalId',
            headerName: 'Series ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,

        },
        {
            field: 'seriesName',
            headerName: 'Series Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 250,

        },
        {
            field: 'derivativeOfProductId',
            headerName: 'Derivative Of',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,

        },
        {
            field: 'derivativeOfSeriesId',
            headerName: 'Derivative of Series',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 250,

        },
//
        {
            field: 'photoStartDate',
            headerName: 'Photo Start',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'lengthMinutes',
            headerName: 'Length',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 60,

        },
        {
            field: 'm4mktGroup',
            headerName: 'Made-For Market',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'initMkt',
            headerName: 'Initial Market',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'genre',
            headerName: 'Genre',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'productionType',
            headerName: 'Production Type',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'broadcastsPerWeek',
            headerName: 'Broadcasts Per Week',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'budget',
            headerName: 'Budget',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'productionCost',
            headerName: 'Production Cost',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'producer',
            headerName: 'Producer',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'financialCode',
            headerName: 'Financial Code',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },
        {
            field: 'eidr',
            headerName: 'EIDR',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 100,

        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>

                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer sx={{height: "100%", width: 1600}}
                    anchor='right'
                    open={useSelector((state) => state.obligationHierarchySlc.value.productGridOpen)}
                    onClose={closeProductDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Product Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro
                            style={{height: 600, width: 1000}}
                            aria-label={"ProductDataDrawerGrid"}
                            rows={productData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}
                            columns={columns(fetchProductData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            rowThreshold={0}
                            components={{
                                Toolbar: CustomToolbar,
                            }}

                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************

}

